import * as React from 'react';
import { UserProfileSectionType } from 'app/routes/route-constants';
import { Configuration } from './types';
import { TabItem } from 'app/components';
import * as navigate from 'app/area/shared/navigation';
import { UserProfileTranslation } from 'app/area/user-profile/constants';

interface TabItemWrapperProps {
  id: number;
  item: Configuration;
  active: boolean;
  translation: UserProfileTranslation;
}

class TabItemWrapper extends React.PureComponent<TabItemWrapperProps> {

  private onClick = (e: React.MouseEvent) => {
    e.preventDefault();
    navigate.to(this.props.item.url);
  };

  public render() {

    const { id, item, active, translation } = this.props;

    return <TabItem
      id={id}
      active={active}
      valid={true}
      url={undefined}
      label={{ text: item.label(translation) }}
      iconUrl={item.iconUrl}
      onClick={this.onClick}
      visible={item.visible}
    />;
  }
}

export const userProfileTabsFactory = (conf: Configuration[], activeSection: UserProfileSectionType,
  translation: UserProfileTranslation) => {

  return (onClick) => <ul id="tabcontainer" role="tablist" onClick={onClick}>
    {conf.map((item, index) =>
      <TabItemWrapper
        key={item.section}
        id={index}
        item={item}
        active={activeSection === item.section}
        translation={translation}
      />)}
  </ul>;
};
